

export const wxOtherLinkData: {
  link: string;
  title: string;
  needLogin?: boolean;
  outerLink?: true;
  isOpenNewWindow?: boolean;
  isNew?: boolean;
  onClick?: (e?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}[] = [
  {
    link: '/wx/',
    title: '首页',
    isOpenNewWindow: false,
  },
  {
    link: '/wx/mass',
    title: '群发功能',
    isOpenNewWindow: false,
  },
  {
    link: '/wx/qrcode',
    title: '渠道二维码',
    isOpenNewWindow: false,
  },
  {
    link: '/wx/poster',
    title: '裂变海报',
    isOpenNewWindow: false,
  },
  {
    link: '/wx/auto-reply',
    title: '自动回复',
    isOpenNewWindow: false,
  },
  {
    link: '/wx/menu',
    title: '自定义菜单',
    isOpenNewWindow: false,
  },
  {
    link: 'https://www.yuque.com/kuaizhan_help/weixinnormal/kgfo6m',
    title: '帮助文档',
    outerLink: true,
    isOpenNewWindow: false,
  },
  {
    link: '/wx/mass-price',
    title: '定价',
    isOpenNewWindow: false,
    isNew: true,
  },
]